import React from 'react'
import { Button, IconButton, Menu, MenuItem } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import { FormattedMessage } from 'react-intl'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import { TableRowBackground } from '../../../../utils/colors'
import { useStyles } from './Styles'
import { UserConsumer, UserProvider } from '../../../../UserContext'
import { AuthenticatedUserConsumer } from '../../../../AuthenticatedUserContext'
import { NavLink } from 'react-router-dom'
import { formatRoute } from 'react-router-named-routes'
import { NamedRoutes } from '../../../../routes'

const UserActionsMenu = ({ id, handleNotificationCall }) => {
  let classes = useStyles()
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [viewUserMenu, setViewUserMenu] = React.useState(false)
  const open = Boolean(anchorEl)

  const handleClick = (event) => {
    setViewUserMenu(true)
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
    setViewUserMenu(false)
  }


  const StyledMenu = withStyles({
    paper: {
      border: `1px solid ${TableRowBackground}`
    }
  })((props) => (
    <Menu
      elevation={4}
      getContentAnchorEl={null}
      anchorOrigin={{
        vertical: 'center',
        horizontal: 'left'
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left'
      }}
      disableScrollLock
      {...props}
    />
  ))


  return (
    <AuthenticatedUserConsumer>
      {({ adminSectionType }) => (
        <UserProvider uid={id} adminSectionType={adminSectionType} handleNotificationCall={handleNotificationCall}>
          <UserConsumer>
            {({ sendResetPasswordOTP }) => (
              <div>
                <IconButton
                  aria-label="more"
                  aria-controls="long-menu"
                  aria-haspopup="true"
                  onClick={handleClick}
                >
                  <MoreVertIcon/>
                </IconButton>
                {!!viewUserMenu &&
                <StyledMenu
                  id="long-menu"
                  anchorEl={anchorEl}
                  keepMounted
                  open={open}
                  onClose={handleClose}
                  className={classes.UserCustomMenu}
                >
                  <MenuItem onClick={handleClose}>
                    <NavLink to={formatRoute(NamedRoutes.subscription.user.editProfile, { id: id })}>
                      <FormattedMessage id='UserMenu.editProfile'/>
                    </NavLink>
                  </MenuItem>
                  <MenuItem onClick={handleClose}>
                    <Button color="primary" onClick={sendResetPasswordOTP}>
                      <FormattedMessage id='UserMenu.SendResetPasswordOTP'/>
                    </Button>
                  </MenuItem>
                </StyledMenu>
                }
              </div>
            )}
          </UserConsumer>
        </UserProvider>
      )}
    </AuthenticatedUserConsumer>
  )
}

export default UserActionsMenu
